import { render, staticRenderFns } from "./UnlockRdTrial.vue?vue&type=template&id=4c899674"
import script from "./UnlockRdTrial.vue?vue&type=script&lang=ts"
export * from "./UnlockRdTrial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports